import * as React from "react";
import { Redirect } from "react-router-dom";
import { CssBaseline } from "@material-ui/core";
import SearchHeader from "../layouts/SearchHeader";
import Tutorial from "modules/development/components/layouts/Tutorial";
import DevelopmentGridList from "../layouts/DevelopmentGridList";
import TrialExpired from "../layouts/TrialExpired";
import TrialMessage from "../layouts/TrialMessage";
import { Grid } from "@material-ui/core";
import { DevelopmentService } from "../../DevelopmentService";
import { DevelopmentStore } from "../../DevelopmentStore";
import { LoginStore } from "modules/login/LoginStore";
import ReactLoading from "react-loading";
import { observer } from "mobx-react";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import { ProfileStore } from "modules/profile/ProfileStore";
import SubscribeNowCard from "modules/development/components/layouts/SubscribeNowCard";
import i18n from "i18n";

@observer
class Development extends React.Component {
  state = { developments: [], ready: false, cancelEdit: false, a: "" };

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    this.getDevelopments();
    document.title = `Rubk - ${i18n.menu.development}`;
    ModelMapStore.modelMapCheck = [];
    ProfileStore.resetStore();
  }

  componentWillUnmount() {
    document.title = "Rubk";
    DevelopmentStore.resetStore();
  }

  async getDevelopments() {
    if (LoginStore.userAuth != undefined) {
      await DevelopmentService.fetchDevelopments();
      this.setState({ ready: true });
    }
  }

  public render() {
    const { ready } = this.state;

    if (!LoginStore.trialUserIsVerified()) {
      return <Redirect from="/check-email" to="/check-email" />;
    }

    return (
      <React.Fragment>
        <CssBaseline />
        {!ready ? (
          <ReactLoading type="bars" color={"back"} />
        ) : (
          <>
            <Grid container>
              <Grid item xs={12}>
                <SearchHeader />
              </Grid>
              <Grid item xs={12}>
                <DevelopmentGridList />
              </Grid>
              {LoginStore.expiredTrial() && <TrialExpired />}
              <TrialMessage />
            </Grid>
            <SubscribeNowCard />
            <Tutorial />
          </>
        )}
      </React.Fragment>
    );
  }
}

export default Development;



// WEBPACK FOOTER //
// ./src/modules/development/components/pages/Development.tsx